import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ImagemTituloDescricaoContainerService } from './imagem-titulo-descricao-container.service';
import { ImagemTituloDescricaoData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-imagem-titulo-descricao-container',
  template: `
    <fcp-imagem-titulo-descricao
      [imagemTituloDescricao]="data | async"
    ></fcp-imagem-titulo-descricao>
  `
})
export class ImagemTituloDescricaoContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<ImagemTituloDescricaoData>;
  constructor(private imagemTituloDescricaoContainerService: ImagemTituloDescricaoContainerService) {}

  ngOnInit() {
    this.data = this.imagemTituloDescricaoContainerService.getImagemTituloDescricao(this.id);
  }
}
